import { render, staticRenderFns } from "./SurgSpecialApproval.vue?vue&type=template&id=259c3b2c&scoped=true"
import script from "./SurgSpecialApproval.vue?vue&type=script&lang=js"
export * from "./SurgSpecialApproval.vue?vue&type=script&lang=js"
import style0 from "./SurgSpecialApproval.vue?vue&type=style&index=0&id=259c3b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259c3b2c",
  null
  
)

export default component.exports